import JournalField from 'components/group/form/fields/JournalField'

import PlotBox from './PlotBox'

export default function JournalBox() {
  return (
    <PlotBox>
      <JournalField />
    </PlotBox>
  )
}
